import { render } from "./FaceView.vue?vue&type=template&id=30b5996e&scoped=true"
const script = {}

import "./FaceView.vue?vue&type=style&index=0&id=30b5996e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30b5996e"]])

export default __exports__